import { render, staticRenderFns } from "./ECommerceDevelopment.vue?vue&type=template&id=05ad870c&"
import script from "./ECommerceDevelopment.vue?vue&type=script&lang=js&"
export * from "./ECommerceDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports